<template>
  <router-link
    :to="{ name: routeName, params: { company_id: item.id }, query: query }"
  >
    <div class="white-blocks catalog__in">
      <div class="catalog__in-content">
        <div class="catalog__in-content-top mb-3">
          <div class="catalog__in-content-left">
            <div class="catalog__in-img">
              <img
                v-if="item.image"
                :alt="item.title"
                :src="thumb(item.image, 300)"
              />
              <img v-else :src="placeholderImage" alt="no-image" />
            </div>
          </div>
          <div class="catalog__in-content-right">
            <p class="catalog__name">{{ item.title }}</p>
            <div class="catalog__subname">
              {{ category.title }}
            </div>
            <div class="rate-wrap">
              <div class="rate">
                <rate :rating="item.rating" />
              </div>
              <span>
                {{ $tc("catalog.reviews_count", item.reviews_count || 0) }}
              </span>
            </div>
          </div>
        </div>
        <div class="catalog__in-text">
          <p v-if="description" class="mb-3">
            {{ description }}
          </p>
          <div
            v-if="item.phones && item.phones.length"
            class="catalog__phone mb-2 font-weight-normal"
          >
            <a> <span class="icon-telephone"></span> {{ item.phones[0] }} </a>
            <span>
              <a
                v-if="!isPhoneShown"
                class="show-phone"
                href="#"
                @click.prevent="showPhone(item.id)"
              >
                {{ $t("Show") }}
              </a>
            </span>
          </div>
          <div v-if="item.location" class="catalog__address font-weight-normal">
            <span class="icon-Map_pointer"></span> {{ item.location.address }}
          </div>
        </div>
      </div>
    </div>
  </router-link>
</template>

<script>
import Rate from "../../components/Rate";
import LanguageMixin from "../../mixins/LanguageMixin";

export default {
  name: "Item",

  components: {
    Rate,
  },

  mixins: [LanguageMixin],

  props: {
    item: { type: Object, required: true },
  },

  data() {
    return {
      isPhoneShown: false,
    };
  },

  computed: {
    placeholderImage() {
      return window.IMAGE_PLACEHOLDER;
    },
    query() {
      return this.$store.getters.parseParams;
    },
    description() {
      let item = this.item;

      if (item.description === null || item.description === "") return "";
      return this.replaceComma(item.description);
    },
    routeName() {
      let route_name;
      switch (true) {
        case this.$route.name === "search_by_word":
          route_name = "company_found_by_word";
          break;
        case this.$route.name === "company_found_by_word":
          route_name = "company_found_by_word";
          break;
        default:
          route_name = "company";
      }
      return route_name;
    },
    category() {
      if (!CATEGORY_LIST.length) return "";

      let category_id = this.$route.params.id;
      if (typeof category_id === "undefined") {
        if (this.item.categories.length)
          return CATEGORY_LIST.find((i) => {
            return i.id === parseInt(this.item.categories[0].id);
          });
        return "";
      }

      return CATEGORY_LIST.find((i) => {
        return i.id === parseInt(category_id);
      });
    },
  },

  mounted() {},

  methods: {
    replaceComma($text) {
      return $text.replace(",", ", ");
    },
    showPhone(id) {
      let vm = this;
      $.ajax({
        url: "/company/" + id + "/getPhones",
        method: "GET",
        headers: {
          "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content"),
        },
        success(response) {
          vm.item.phones = response;
          vm.isPhoneShown = true;
        },
      });
    },
  },
};
</script>
